// extracted by mini-css-extract-plugin
module.exports = {"restorepassword":"restore-password_restorepassword__9QUTZ"};